/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle00Icon16Light } from './NumberCircle00Icon16Light';
import { NumberCircle00Icon16Regular } from './NumberCircle00Icon16Regular';
import { NumberCircle00Icon16Solid } from './NumberCircle00Icon16Solid';
import { NumberCircle00Icon20Light } from './NumberCircle00Icon20Light';
import { NumberCircle00Icon20Regular } from './NumberCircle00Icon20Regular';
import { NumberCircle00Icon20Solid } from './NumberCircle00Icon20Solid';
import { NumberCircle00Icon24Regular } from './NumberCircle00Icon24Regular';
import { NumberCircle00Icon24Solid } from './NumberCircle00Icon24Solid';
import { NumberCircle00Icon32Regular } from './NumberCircle00Icon32Regular';
import { NumberCircle00Icon64Regular } from './NumberCircle00Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle00Icon16Light,
        regular: NumberCircle00Icon16Regular,
        solid: NumberCircle00Icon16Solid,
    },
    20: {
        light: NumberCircle00Icon20Light,
        regular: NumberCircle00Icon20Regular,
        solid: NumberCircle00Icon20Solid,
    },
    24: {
        regular: NumberCircle00Icon24Regular,
        solid: NumberCircle00Icon24Solid,
    },
    32: {
        regular: NumberCircle00Icon32Regular,
    },
    64: {
        regular: NumberCircle00Icon64Regular,
    },
};
export var NumberCircle00Icon = forwardRef('NumberCircle00Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
